import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import productData from '../assets/products/productData';
import Aos from 'aos';

function TestProductDetails() {
  const { id } = useParams();

  const product = productData.find(item => item.productId === id);
  const [selectedImage, setSelectedImage] = useState(product?.productImages[0]);

  useEffect(() => {
    Aos.init({
      duration: 1000,
      easing: 'ease-in-out', 
      once: false, 
      mirror: false, 
    });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top whenever the component loads or the id changes
  }, [id]);

  if (!product) {
    return (
      <div className="container text-center">
        <h2 style={{ color: '#d22127' }}>Product not found</h2>
      </div>
    );
  }

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  return (
    <div>
      <Container>
        <br/>
        <br/>
        <Row>
          <Col md={6} className="text-center mb-3">
            {product && (
              <Image
                src={`${selectedImage}`} 
                alt="Selected"
                fluid
                style={{ maxWidth: '100%', maxHeight: '300px', objectFit: 'contain' }} 
              />
            )}
          </Col>
          <Col md={6}>
            {product && (
              <>
                <br/>
                <h2 style={{ color: 'rgb(210, 33, 39)' }}>{product.productName}</h2>
                <p className='fw-bold' style={{ whiteSpace: 'pre-wrap' }}>{product.description}</p>
                <p className='fw-bold' style={{ whiteSpace: 'pre-wrap' }}>{product.application}</p>
              </>
            )}
          </Col>
        </Row>
        <Row className="mt-4">
          {product && product.productImages.map((image, index) => (
            <Col xs={3} key={index} className="text-center mb-4">
              <Image
                src={`${image}`}
                alt={`Thumbnail ${index + 1}`}
                onClick={() => handleImageClick(image)} 
                thumbnail
                className={`img-fluid ${selectedImage === image ? 'border border-warning' : ''}`} 
                style={{ cursor: 'pointer', maxHeight: '100px', objectFit: 'cover' }} 
              />
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default TestProductDetails;
